import { render, staticRenderFns } from "./WheelsTripRequirements.vue?vue&type=template&id=503081d0&scoped=true"
import script from "./WheelsTripRequirements.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsTripRequirements.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsTripRequirements.vue?vue&type=style&index=0&id=503081d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503081d0",
  null
  
)

export default component.exports